/** Win11-style unary wrappers stored in the expression string */

export type UnarySymbolKind = 'fact' | 'sqr' | 'inv' | 'sqrt' | 'log10' | 'ln';

const UNARY_RE = /^(fact|sqr|inv|sqrt|log10|ln)\(/i;

export function wrapUnarySymbol(operand: string, kind: UnarySymbolKind): string {
  const inner = operand.replace(/\s+/g, '');
  if (!inner) throw new Error('invalid');
  return `${kind}(${inner})`;
}

export function isUnaryWrappedOperand(operand: string): boolean {
  return UNARY_RE.test(operand.replace(/\s+/g, ''));
}

export function hasUnarySymbols(expr: string): boolean {
  return /\b(fact|sqr|inv|sqrt|log10|ln)\(/i.test(expr);
}

/** Expand symbolic unary calls for mathjs evaluation */
export function expandUnarySymbols(expr: string): string {
  let s = expr;
  let prev: string;
  do {
    prev = s;
    s = s.replace(/\bfact\(([^()]+)\)/gi, 'factorial($1)');
    s = s.replace(/\bsqr\(([^()]+)\)/gi, '($1)^2');
    s = s.replace(/\binv\(([^()]+)\)/gi, '1/($1)');
  } while (s !== prev);
  return s;
}
